import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/reports/interviews'
export default {
  namespaced: true,
  state: {
    details: [],
    dataCount: 0,
    summary: [],
    meets: {
      data: [],
      chart: {
        categories: [],
        series: [],
      },
    },
    statuses: {
      data: [],
      chart: {
        categories: [],
        series: [],
      },
    },
    subjects: {
      data: [],
      chart: {
        categories: [],
        series: [],
      },
    },
    filter: {
      sdate: null,
      edate: null,
      id_users: null,
      limit: 25,
      start: 0,
    },
  },
  getters: {
    filterParams(state) {
      return state.filter
    },
    details(state) {
      return state.details
    },
    dataCount(state) {
      return state.dataCount
    },
    summary(state) {
      return state.summary
    },
    meets(state) {
      return state.meets
    },
    statuses(state) {
      return state.statuses
    },
    subjects(state) {
      return state.subjects
    },
  },
  mutations: {
    SET_REPORT_DATA(state, data) {
      state.summary = data.summary
      state.meets = data.meets
      state.statuses = data.statuses
      state.subjects = data.subjects
    },
    SET_DETAIL_DATA(state, data) {
      state.details = data.data
      state.dataCount = data.count
    },
  },
  actions: {
    getReport({ commit }, data) {
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_REPORT_DATA', response.data)
        })
        .catch(error => console.error(error))
    },
    getDetail({ commit }, data) {
      axiosIns
        .post(`${ROOT_URL}/details`, data)
        .then(response => {
          commit('SET_DETAIL_DATA', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
